import instance from "utils/instance";
import Page from "types/page";
import { EmailDomainListParams } from "types/dto/request/accessControl";
import { EmailDomainListResponse } from "types/dto/response/accessControl";
import { components } from "types/api";

type EmailDomainCreateRequest = components["schemas"]["EmailDomainCreateRequest"];

export function fetchEmailDomains(params: EmailDomainListParams) {
  return instance.get<Page<EmailDomainListResponse>>("/email-domains", { params });
}

export function fetchEmailDomain(id: number) {
  return instance.get<EmailDomainListResponse>(`/email-domains/${id}`);
}

export function createEmailDomain(data: EmailDomainCreateRequest) {
  return instance.post<void>("/email-domains", data);
}

export function updateEmailDomain(id: number, data: EmailDomainCreateRequest) {
  return instance.put<EmailDomainListResponse>(`/email-domains/${id}`, data);
}

export function deleteEmailDomain(id: number) {
  return instance.delete<void>(`/email-domains/${id}`);
}
